import { ChevronDownIcon } from '@chakra-ui/icons'
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tab,
  TabList,
  TabProps,
  Tabs,
} from '@chakra-ui/react'
import { DataListTab, ScreenContext } from '@hb/react'
import { useContext, useMemo } from 'react'
import { ItemViewProps } from '../../types'

const SectionTab = ({
  tab,
  ...props
}: TabProps & { tab: DataListTab<any, any, ItemViewProps<any, any>> }) => (
  <Tab
    _selected={{
      fontWeight: 500,
      background: tab.activeTabBackgroundColor || 'white',
      color: tab.activeTabTextColor || 'gray.600',
      borderLeft: '1px solid',
      borderRight: '1px solid',
      borderColor: 'gray.200',
      borderBottom: 'none',
      textShadow: tab.activeTabShadow ? '1px 1px 3px #00000088' : 'none',
    }}
    _dark={{
      background: tab.tabBackgroundColor || 'gray.700',
      _selected: {
        background: tab.activeTabBackgroundColor || 'gray.900',
        color: tab.activeTabTextColor || 'gray.100',
        borderColor: 'gray.800',
      },
    }}
    zIndex={2}
    fontFamily="Hero-New"
    color={tab.tabTextColor}
    background={tab.tabBackgroundColor || '#efefef'}
    {...props}
  />
)

const DesktopDataListTabs = ({
  onChange: handleTabChange,
  index: tabIndex,
  tabs,
}: {
  onChange: (index: number) => void
  index: number
  tabs: Record<string, DataListTab<any, any, ItemViewProps<any, any>>>
}) => {
  const { rightJustifyTabs, leftJustifyTabs } = useMemo(() => {
    const tabNames = Object.keys(tabs)
    const rightJustify = tabNames.filter(t => tabs[t].rightJustifyTab)
    const leftJustify = tabNames.filter(t => !tabs[t].rightJustifyTab)
    return { rightJustifyTabs: rightJustify, leftJustifyTabs: leftJustify }
  }, [tabs])

  return (
    <Tabs variant="enclosed-colored" onChange={handleTabChange} index={tabIndex}>
      <TabList>
        {leftJustifyTabs.map(tName => (
          <SectionTab tab={tabs[tName]} key={tName}>
            {tName}
          </SectionTab>
        ))}
        <Flex ml="auto">
          {rightJustifyTabs.map(tName => (
            <SectionTab tab={tabs[tName]} key={tName}>
              {tName}
            </SectionTab>
          ))}
        </Flex>
      </TabList>
    </Tabs>
  )
}

const MobileDataListTabs = ({
  onChange: handleTabChange,
  index: tabIndex,
  tabs,
}: {
  onChange: (index: number) => void
  index: number
  tabs: Record<string, DataListTab<any, any, ItemViewProps<any, any>>>
}) => {
  const tabNames = Object.keys(tabs)
  return (
    <Flex w="100%">
      <Menu matchWidth>
        <MenuButton
          bg="transparent"
          _hover={{
            bg: 'transparent',
          }}
          _active={{
            bg: 'transparent',
          }}
          w="100%"
          as={Button}
          rightIcon={<ChevronDownIcon />}>
          {tabNames[tabIndex]}
        </MenuButton>
        <MenuList>
          {tabNames.map((tName, i) => (
            <MenuItem key={tName} onClick={() => handleTabChange(i)}>
              {tName}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Flex>
  )
}

export const DataListTabs = (props: {
  onChange: (index: number) => void
  index: number
  tabs: Record<string, DataListTab<any, any, ItemViewProps<any, any>>>
}) => {
  const { isMobile } = useContext(ScreenContext)

  return isMobile ? <MobileDataListTabs {...props} /> : <DesktopDataListTabs {...props} />
}
